import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, adminOnly = false }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    // AuthCallback handles session_id hash; wait for it
    if (window.location.hash?.includes("session_id=")) {
        return (
            <div className="min-h-[60vh] grid place-items-center">
                <Loader2 size={22} className="animate-spin text-[#C4A977]" />
            </div>
        );
    }

    if (loading) {
        return (
            <div className="min-h-[60vh] grid place-items-center">
                <Loader2 size={22} className="animate-spin text-[#C4A977]" />
            </div>
        );
    }

    if (!user) {
        return (
            <Navigate
                to="/logga-in"
                state={{ from: location.pathname }}
                replace
            />
        );
    }

    if (adminOnly && user.role !== "admin") {
        return <Navigate to="/portal" replace />;
    }

    return children;
}
